import React, { useEffect, useRef } from 'react';
import './VerticalSlider.css';


const VerticalSlider = ({ scrollDown, reviews }) => {
  const sliderRef = useRef(null);

  // useEffect(() => {
  //   const slider = sliderRef.current;
  //   let interval = setInterval(() => {
  //     slider.scrollTop += scrollDown ? 1 : -1;
  //     if (slider.scrollTop <= 0) {
  //       slider.scrollTop = slider.scrollHeight / 2;
  //     }
  //     if (slider.scrollTop >= slider.scrollHeight / 2) {
  //       slider.scrollTop = 0;
  //     }
  //   }, 50); // Adjust speed here

  //   slider.addEventListener('mouseover', () => clearInterval(interval));
  //   slider.addEventListener('mouseout', () => {
  //     interval = setInterval(() => {
  //       slider.scrollTop += scrollDown ? 1 : -1;
  //       if (slider.scrollTop <= 0) {
  //         slider.scrollTop = slider.scrollHeight / 2;
  //       }
  //       if (slider.scrollTop >= slider.scrollHeight / 2) {
  //         slider.scrollTop = 0;
  //       }
  //     }, 50);
  //   });

  //   return () => clearInterval(interval);
  // }, [scrollDown]);


  useEffect(() => {
    const slider = sliderRef.current;
    let interval = setInterval(() => {
      if (scrollDown) {
        // Scroll from bottom to top
        slider.scrollTop += 1;
        if (slider.scrollTop >= slider.scrollHeight / 2) {
          slider.scrollTop = 0; // Reset to top
        }
      } else {
        // Scroll from top to bottom
        slider.scrollTop -= 1;
        if (slider.scrollTop <= 0) {
          slider.scrollTop = slider.scrollHeight / 2; // Reset to bottom
        }
      }
    }, 50); // Adjust speed here
  
    // Pause on hover
    slider.addEventListener('mouseover', () => clearInterval(interval));
    slider.addEventListener('mouseout', () => {
      interval = setInterval(() => {
        if (scrollDown) {
          // Scroll from bottom to top
          slider.scrollTop += 1;
          if (slider.scrollTop >= slider.scrollHeight / 2) {
            slider.scrollTop = 0; // Reset to top
          }
        } else {
          // Scroll from top to bottom
          slider.scrollTop -= 1;
          if (slider.scrollTop <= 0) {
            slider.scrollTop = slider.scrollHeight / 2; // Reset to bottom
          }
        }
      }, 50);
    });
  
    return () => clearInterval(interval);
  }, [scrollDown]);

  return (
    <div className='slider-container' ref={sliderRef}>
      <div className='slider-content'>
        {reviews.concat(reviews).map((review, index) => (
          <div className='card' key={index}>
            <p className='review-text'>{review.text}</p>
            {/* <div style={{ display: 'flex', gap: '1rem' }}>
              <img src={review.avatar} alt='Avatar' className='avatar' />
              <p
                className='ptag'
                style={{ position: 'relative', bottom: '0.5rem' }}
              >
                Ankesh
              </p>
            </div> */}
          </div>
        ))}
      </div>
    </div>
  );
};

export default VerticalSlider;
